import React from "react";
import useMedia from 'use-media';
import NotFoundDesktop from './NotFoundDesktop.js';
import NotFoundMobile from './NotFoundMobile.js';

 /* eslint-disable react/prop-types */
function NotFound(props) {
    const isLargeScreen = useMedia('(min-width: 601px)');
    const isSmallScreen = useMedia('(max-width: 600px)');
    const isMoreThen2k = useMedia('(min-width: 1440px)');

    return (
        <div>
             {/* <a href="/" className="link"></a> */}
            {isLargeScreen && <NotFoundDesktop isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} message={props.message} isMoreThen2k={isMoreThen2k} />}
            {isSmallScreen && <NotFoundMobile isLargeScreen={isLargeScreen} isSmallScreen={isSmallScreen} message={props.message} isMoreThen2k="false"/>}
        </div>
        );
}


export default NotFound;